module.exports = __webpack_public_path__ + "img/impact-story-1.3af2b1b3.png";